module.exports = __webpack_public_path__ + "media/categories/1003-5cd19b10.svg";